const initialReturnExchangeState = {
  userData: {},
  storeAddresses: {},
  disableButton: false
};

function returnExchange(state = initialReturnExchangeState, action) {
  switch (action.type) {
    case 'SET_RETURN_EXCHANGE_ITEMS':
      return { ...state, items: action.items };

    case 'SET_RETURN_REASONS':
      return { ...state, returnReason: action.returnReason };

    case 'SET_EXCHANGE_REASONS':
      return { ...state, exchangeReason: action.exchangeReason };

    case 'SET_RETURN_EXCHANGE_ORDER':
      let newState = action.returnExchangeOrder;
      newState.userData = state.userData ? state.userData : action.userData || {};
      return newState;

    case 'UPDATE_EXCHANGE_STORE_DATA':
      newState = { ...state };
      if (action.key && action.value) {
        newState[action.key] = action.value;
      }
      if (action.deleteKey) {
        delete newState[key];
      }
      return newState;

    case 'SET_RETURN_SUMMARY_DATA':
      return { ...state, returnSummary: action.returnSummary };
    case 'DISABLE_RETURN_SUBMIT_BUTTON':
      return { ...state, disableButton: action.disableButton };

    case 'SET_STORE_ADDRESS':
      return { ...state, storeAddresses: action.storeAddresses };

    default:
      return state;
  }
}

export default returnExchange;
